var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ks-dialog-wrapper",class:{ 'ks-dialog-wrapper-inline': _vm.hasActivator }},[(_vm.hasActivator)?_c('div',{staticClass:"ks-dialog-activator"},[_vm._t("activator",null,{"on":_vm.activatorListeners})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }